import { api } from '../service/NetworkUtility';
import { logError } from './ErrorService';

export const RequestParameters = (company, paymentType) => {
    return { company, paymentType };
}

let getSummaryAbortController = new AbortController();

export const makeRequest = (request, successHandler) => {
    const { company, paymentType } = request;

    getSummaryAbortController.abort();
    getSummaryAbortController = new AbortController();

    if (company == null || typeof company === 'undefined') {
        return;
    }

    const url = `/companies/${company}/payments/types/${paymentType}/summary/status`;
    api.get(url, {
        signal: getSummaryAbortController.signal
    })
        .then(transformResponse)
        .then((data) => {
            successHandler(data.companyTotals);
        })
        .catch(function (error) {
            // Abort errors can be ignored 
            if (error?.code !== 'ERR_CANCELED') {
                if (error?.response?.status === 401 || error?.response?.status === 403) {
                    //unauthorized user - log unauth attempt and redirect
                    logError("Unauthorized user attempt", () => {
                        window.location = "/unauthorizedUser?pss";
                    });
                } else {
                    //TODO: add an error handler to the caller of this
                    console.log("Unable to retrieve Payments by Status information.");
                }
            }
        });
}

const transformResponse = (response) => {
    return response.data;
}